require('./facebook-component')

window.Vue = require('vue').default;
Vue.component('feedbackform', require('./components/FeedbackForm.vue').default);


export let commonPageData = Vue.observable({
    tourniquetData: null,
    feedbackFormshow: false,
    feedbackFormOption: null
});

const feedbackFormComponent = new Vue({
    el: '#questionForm',
    computed: {
        showForm() {
            return commonPageData.feedbackFormshow;
        }
    }
});

document.querySelectorAll('[data-event="show-question-form"]').forEach(link => {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        commonPageData.feedbackFormshow = true;
        commonPageData.feedbackFormOption = this.dataset['option'];
    })
})

if (!canUseWebp()) {
    document.querySelector('body').classList.add('no-webp');
}

function canUseWebp() {
    const elem = document.createElement('canvas');
    if (!!(elem.getContext && elem.getContext('2d'))) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
}

const mailLabel = document.querySelector('[data-el="mail-label"]');
mailLabel.textContent = UnCryptMailto(mailLabel.getAttribute('data-mail')).replace('mailto:', '');

function UnCryptMailto(s) {
    var n = 0;
    var r = "";
    for (var i = 0; i < s.length; i++) {
        n = s.charCodeAt(i);
        if (n >= 8364) {
            n = 128;
        }
        r += String.fromCharCode(n - 1);
    }
    return r;
}

function linkTo_UnCryptMailto(s) {
    location.href = UnCryptMailto(s);
}

document.querySelector('[data-el="mail-link"]').addEventListener('click', function (e) {
    e.preventDefault();
    linkTo_UnCryptMailto(this.getAttribute('data-mail'));
})

const body = document.querySelector('body');
const modals = document.querySelectorAll('.custom-modal');
const openShareBtn = document.querySelectorAll('[data-event="open-share"]');
const shareModal = document.querySelector('[data-block="share-modal"]');
const closeShareBtn = document.querySelector('[data-event="close-share"]');

if (openShareBtn.length) {
    openShareBtn.forEach(btn => {
        btn.addEventListener('click', function () {
            shareModal.classList.add('active')
        })
    })
    if (closeShareBtn) {
        closeShareBtn.addEventListener('click', function () {
            shareModal.classList.remove('active')
        })
    }
}


const dropdowns = document.querySelectorAll('[data-event="dropdown-toggle"]');
if (dropdowns.length) {
    dropdowns.forEach(dropdown => {
        dropdown.addEventListener('click', function () {
            this.classList.toggle('active');
        })
    });
}
body.addEventListener('click', function (e) {
    if (document.querySelector('.custom-modal.active') && !e.target.classList.contains('custom-modal-content') && !e.target.closest('.custom-modal-content')
        && !e.target.classList.contains('custom-modal-toggle') && !e.target.classList.contains('disable-click-outside')) {
        closeModals()
    }

    if (!e.target.classList.contains('dropdown-default') && !e.target.closest('.dropdown-default')) {
        dropdowns.forEach(dropdown => dropdown.classList.remove('active'))
    }

    if (body.classList.contains('mobile-menu-open') && !e.target.classList.contains('mobile-menu-toggle') && !e.target.closest('.mobile-menu-toggle') && !e.target.classList.contains('header-links') && !e.target.closest('.header-links')) {
        console.log(e.target);
        closeMenu()
    }
})

window.onkeyup = (event) => {
    if (event.code === "Escape" && body.classList.contains('modal-open')) {
        closeModals()
    }
}

function closeModals() {
    modals.forEach(modal => {
        modal.classList.remove('active')
    })
    body.classList.remove('modal-open')
}

const copyLinkBtns = document.querySelectorAll('[data-event="copy-link"]');

if (copyLinkBtns.length !== 0) {
    Array.from(copyLinkBtns).forEach(btn => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            const el = document.createElement('div');
            el.innerHTML = this.dataset.link || window.location.href;
            document.body.appendChild(el);
            const range = new Range();
            range.selectNode(el);
            const select = window.getSelection();
            select.removeAllRanges();
            select.addRange(range);
            document.execCommand('copy');
            el.remove();

            if (shareModal) {
                shareModal.classList.remove('active');
            }
        })
    })
}

const mobileMenuToggle = document.querySelector('[data-event="open-mobile-menu"]');
const mobileMenu = document.querySelector('[data-el="mobile-menu"]');
const closeMobileMenu = document.querySelector('[data-event="close-mobile-menu"]');

mobileMenuToggle.addEventListener('click', function () {
    mobileMenu.classList.add('active');
    body.classList.add('mobile-menu-open')
})

function closeMenu() {
    mobileMenu.classList.remove('active');
    body.classList.remove('mobile-menu-open')
}
closeMobileMenu.addEventListener('click', function () {
    closeMenu();
})

document.querySelectorAll('.header-link').forEach(link => {
    link.addEventListener('click', function () {
        if (mobileMenu.classList.contains('active')) {
            closeMenu();
        }
    })
})

const instructorItems = document.querySelectorAll('[data-block="instructor-item"]');

if (instructorItems.length !== 0) {
    instructorItems.forEach(item => {
        item.addEventListener('click', function () {
            window.location = this.querySelector('.instructors-card-btn').getAttribute('href');
        })
    })
}
